export const PostMsg = {
    receiveMessage
}

function receiveMessage(callback, source_origin, delay = 100) {
    window.addEventListener("message", function (event) {
      if (event.origin !== source_origin) return;
      callback(event);
    }, false);
}